import type { PersonRatesQuery } from '@sahab/contracts'
import { z } from 'zod'

export const PERSON_RATE_PAGE_SIZES = [25, 50, 100] as const

const pageSize = z
  .number()
  .refine((n): n is (typeof PERSON_RATE_PAGE_SIZES)[number] =>
    (PERSON_RATE_PAGE_SIZES as readonly number[]).includes(n),
  )
  .optional()
  .catch(undefined)

/**
 * People's hourly cost (`/projects/rates`) in the URL: the search, the "missing a rate" view, the page
 * and the person whose history is open in the drawer.
 */
export const personRatesSearchSchema = z.object({
  q: z.coerce.string().trim().max(200).optional().catch(undefined),
  view: z.enum(['missing']).optional().catch(undefined),
  page: z.number().int().min(1).optional().catch(undefined),
  pageSize,
  person: z.uuid().optional().catch(undefined),
})
export type PersonRatesSearch = z.infer<typeof personRatesSearchSchema>

export function toPersonRatesQuery(search: PersonRatesSearch): PersonRatesQuery {
  return {
    q: search.q || undefined,
    missing: search.view === 'missing' ? 'true' : undefined,
    page: search.page ?? 1,
    pageSize: search.pageSize ?? 25,
  }
}
